export default __webpack_public_path__ + "static/media/centroMoons@2x.fbd5a789.webp";